<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex mb-3">
          <b-button-group class="add-button-group">
            <b-btn variant="primary" to="/buy-backs/create">Tambah Data</b-btn>
          </b-button-group>
          <div class="ml-auto" v-if="$store.getters['account/accountData'].role === Roles.ADMIN">
            <b-form-checkbox id="checkbox-trash" v-model="filter.with_trash" name="checkbox-trash" :value="1" :unchecked-value="null">
            Lihat Data Terhapus
            </b-form-checkbox>
          </div>
          <!-- <b-button-group class="add-button-group ml-auto">
            <b-btn variant="success" type="button" @click.prevent="doExport"><font-awesome-icon icon="file-excel"/> Ekspor</b-btn>
          </b-button-group> -->
        </div>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="6" md="4">
              <form-group-input ref="filter-transaction_no" type="text" placeholder="" :need-label="true" label="no. invoice" v-model="filter.transaction_no" id="filter-transaction_no" @keyup="filterTransactionNo" />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input ref="filter-tanggal_transaksi" type="date" placeholder="" :need-label="true" label="tgl transaksi" v-model="filter.tanggal_transaksi" id="filter-tanggal_transaksi" />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input type="enum" label="status" :need-label="true" :options="statusOptions" v-model="filter.approval_status" id="filter-approval_status" />
              <form-group-input type="enum" label="status proses" :need-label="true" :options="dispositionOptions" v-model="filter.disposition_status" id="filter-disposition_status" />
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :delete-reason="false" :can-delete="true" :can-edit="false" :delete-criteria="{ column: 'approval_status', criteria: '===', value: 'draft' }" :data-url="apiUrl.buyBack" :data-columns="columns" :dataParams="dataParams" :defaultDataParams="this.filter">
      <template slot="content_costumer" slot-scope="defaultSlotScope">
        {{ defaultSlotScope.colData.costumer.nama }} <br> <small>No HP: {{ defaultSlotScope.colData.costumer.no_hp }}</small>
      </template>
      <template slot="content_approval_status" slot-scope="defaultSlotScope">
        <b-badge :variant="statusVariant(defaultSlotScope.colData.approval_status)">{{ statusLabel(defaultSlotScope.colData.approval_status) }}</b-badge>
      </template>
    </paginated-table>
  </b-card>
</template>

<script>
// import { objectToOptions } from '@/_helpers'
import paginatedTable from '@/components/PaginatedTable.vue'
import formGroupInput from '@/components/FormGroupInput.vue'
import BuyBack from '@/models/BuyBack.js'
import { Roles, debounce } from '@/_helpers'

const buyBackModel = new BuyBack()

export default {
  components: {
    formGroupInput,
    paginatedTable
  },
  data () {
    return {
      Roles: Roles,
      isLoading: false,
      totalPromiseAreaCount: 0,
      apiUrl: {
        buyBack: buyBackModel.endpoint
      },
      columns: [
        {
          prop: 'transaction_no',
          label: 'No. Invoice',
          deletedDetailHere: true,
          sortable: true,
          resizable: true,
          minWidth: 90,
          wrapInLink: true,
        },
        {
          prop: 'costumer',
          label: 'Penjual',
          resizable: true,
          sortable: true,
          minWidth: 250,
          align: 'left',
        },
        {
          prop: 'tanggal_transaksi',
          label: 'Tanggal',
          align: 'center',
          formatThisDate: true,
          resizable: true,
          sortable: true,
          minWidth: 100,
        },
        // {
        //   prop: 'metode_pembayaran',
        //   label: 
        //   // label: 'Stok',
        //   resizable: true,
        //   sortable: true,
        //   minWidth: 80,
        //   align: 'center',
        // },
        {
          prop: 'total',
          label: 'Total',
          resizable: true,
          sortable: true,
          needCurrency: true,
          minWidth: 125,
          align: 'right',
        },
        {
          prop: 'approval_status',
          label: 'Status',
          hasCustomSlot: true,
          minWidth: 150,
          align: 'center',
        },
      ],
      statusOptions: [
        { value: null, text: 'Semua Status' },
        { value: 'draft', text: 'Draft' },
        { value: 'pending', text: 'Menunggu Persetujuan' },
        { value: 'approved', text: 'Disetujui' },
        { value: 'rejected', text: 'Ditolak' }
      ],
      dispositionOptions: [
        { value: null, text: 'Semua Proses' }, { value: 'pending', text: 'Menunggu Keputusan' }, { value: 'waiting_photo', text: 'Menunggu Foto Pajang' }, { value: 'completed', text: 'Selesai' }, { value: 'rejected', text: 'Ditolak' }
      ],
      filter: {
        with_trash: typeof this.$route.query.with_trash !== 'undefined' ? parseInt(this.$route.query.with_trash) : null,
        transaction_no: typeof this.$route.query.transaction_no !== 'undefined' ? this.$route.query.transaction_no : null,
        tanggal_transaksi: typeof this.$route.query.tanggal_transaksi !== 'undefined' ? this.$route.query.tanggal_transaksi : null,
        approval_status: typeof this.$route.query.approval_status !== 'undefined' ? this.$route.query.approval_status : null,
        disposition_status: typeof this.$route.query.disposition_status !== 'undefined' ? this.$route.query.disposition_status : null,
      },
      dataParams: ['transaction_no', 'with_trash', 'tanggal_transaksi', 'approval_status', 'disposition_status']
    }
  },
  beforeMount () {
    this.$router.push({query: {...this.$route.query}}).catch(() => {})
  },
  watch: {
    'filter.with_trash': function () {
      this.doFilter()
    },
    'filter.tanggal_transaksi': function () {
      this.doFilter()
    },
    'filter.approval_status': function () {
      this.doFilter()
    },
    'filter.disposition_status': function () { this.doFilter() },
  },
  methods: {
    filterTransactionNo() {
      this.debounceFilter(this);
    },
    debounceFilter: debounce((vm) => {
      vm.doFilter()
    }, 350),
    clearForm () {
      this.$nextTick(() => {
        this.filter = {
          transaction_no: null,
          with_trash: null,
          tanggal_transaksi: null,
          approval_status: null,
          disposition_status: null,
        }
        setTimeout(() => {
          this.doFilter()
        }, 100)
      })
    },
    doFilter () {
      this.$refs.dataTable.doFilter(this.filter)
    },
    statusLabel (status) {
      return { draft: 'Draft', pending: 'Menunggu Persetujuan', approved: 'Disetujui', rejected: 'Ditolak' }[status] || status || '-'
    },
    statusVariant (status) {
      return { draft: 'secondary', pending: 'warning', approved: 'success', rejected: 'danger' }[status] || 'secondary'
    },
    doExport () {
      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      const filterArray = [];
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key]) {
          filterArray.push(key + "=" + this.filter[key]);
        }
      });
      filterArray.push('csv=1');

      this.$http.get(buyBackModel.getEndpoint() + "?" + filterArray.join("&")).then(response => {
        const a = document.createElement("a");

        const blob = new Blob([response.data], {type: "octet/stream"});
        a.href = window.URL.createObjectURL(blob);

        a.download = "data_admin.csv";
        a.click();
        this.isLoading = false;
      }).catch(error => {
        this.$store.dispatch('notification/error', error)
        this.isLoading = false;
      })
    }
  }
}
</script>
